import { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom'
import { fetchData } from '../utils/fetch'
import { LanguageContext } from '../utils/lang_provider';

function FooterMenu() {
  const footerMenu = process.env.REACT_APP_FOOTER_MENU;
  const [menuItems, setMenuItems] = useState([]);
  const { language } = useContext(LanguageContext);

  useEffect(() => {
  async function loadMenuItems() {
    try {
      const data = await fetchData(`front/menu/menu-items/${footerMenu}`, language);
      setMenuItems(data);
    } catch (error) {
      console.error('Error loading menu items:', error);
    }
  }

  loadMenuItems();
  }, [footerMenu, language]);

  return (
      <ul className={footerMenu}>
        {menuItems.filter(item => (item.status === 1)).map(item => (
            <li key={item.id}><Link key={item.id} to={item.link}>{item.title}</Link></li>
        ))}
      </ul>
  )
}

export default FooterMenu;
